/**
 * 创建一个事件，用于兼容ie 7 8和标准浏览器。
 * @param {Event} e
 */
const creatEvent = function creatEvent(e) {
    const o = {};

    // 将event的属性复制到自定义的对象上
    for (const name in e) {
        if (typeof e[name] !== 'function') {
            o[name] = e[name];
        }
    }

    // 将事件当做对象的一个属性放置
    o.originalEvent = e;

    // 对在不同浏览器下面表现不一致的属性进行处理
    o.target = e.srcElement || e.target;
    o.relatedTarget = e.relatedTarget || (e.fromElement === o.target ? e.toElement : e.fromElement);
    o.keyCode = e.keyCode || e.which;
    o.which = o.keyCode;

    if (!o.which && e.button !== undefined) {
        o.which = e.button & 1 ? 1 : e.button & 2 ? 3 : e.button & 4 ? 2 : 0;
    }

    // 避免使用非鼠标事件时，对pageX和pageY进行处理
    // 主要是在ie8下面propertychange事件，导致输入回退时的一个显示bug
    if (/^(?:mouse|contextmenu)|click/.test(e.type)) {
        const d = document.documentElement;
        const body = document.body;

        o.pageX =
            e.pageX ||
            e.clientX +
                ((d && d.scrollLeft) || (body && body.scrollLeft) || 0) -
                ((d && d.clientLeft) || (body && body.clientLeft) || 0);

        o.pageY =
            e.pageY ||
            e.clientY +
                ((d && d.scrollTop) || (body && body.scrollTop) || 0) -
                ((d && d.clientTop) || (body && body.clientTop) || 0);
    }

    // 阻止冒泡
    o.stopPropagation = function stopPropagation() {
        if (e.stopPropagation) {
            e.stopPropagation();
        } else {
            e.cancelBubble = true;
        }
    };

    // 阻止默认事件
    o.preventDefault = function preventDefault() {
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            e.returnValue = false;
        }
    };

    return o;
};

/**
 * 创建一个dom事件，这个方法主要是为了兼容 ie 7 8 的事件，移动端不建议使用
 * @param {domElement} elm 触发事件的dom对象，只能传递dom对象
 * @param {string} eventName 事件名称
 * @param {function} fn 事件触发后的回调
 */
const addEventListener = function addEventListener(elm, eventName, fn) {
    if (elm.addEventListener) {
        elm.addEventListener(eventName, fn, false);

        return function removeEventListener() {
            return elm.removeEventListener(eventName, fn);
        };
    } else if (elm.attachEvent) {
        const callback = function callback() {
            const event = creatEvent(window.event);

            return fn.bind(elm)(event);
        };

        elm.attachEvent(`on${eventName}`, callback);

        return function removeEventListener() {
            return elm.detachEvent(`on${eventName}`, callback);
        };
    } else {
        console.error('elm 只能是 domElement 对象');
    }
};

export default addEventListener;
